export const nodeFormConfigs = {
  project: {
    type: 'project' as const,
    nameLabel: 'Project Name',
    descriptionLabel: 'Description',
    descriptionRequired: true,
    showType: false,
    showDueDate: false,
    showAssignee: false,
    showProjects: false,
    showDependencies: false,
    showWorkspace: true,
    showCollaborators: true,
    showHorizon: false,
    showPriority: false,
    showStatus: false,
    workspaceRequired: true,
    collaboratorsLabel: 'Collaborators',
  },
  task: {
    type: 'task' as const,
    nameLabel: 'Name *',
    descriptionLabel: 'Description',
    descriptionRequired: false,
    showType: true,
    showDueDate: true,
    showAssignee: true,
    showProjects: true,
    showDependencies: true,
    showWorkspace: true,
    showCollaborators: true,
    showHorizon: true,
    showPriority: true,
    showStatus: true,
    workspaceRequired: true,
    assigneeLabel: 'Assignee',
    collaboratorsLabel: 'Collaborators',
    projectsLabel: 'Projects',
    dependenciesLabel: 'Dependencies',
  },
  simplified: {
    type: 'project' as const,
    nameLabel: 'Project Name',
    descriptionLabel: 'Description',
    descriptionRequired: true,
    showType: false,
    showDueDate: false,
    showAssignee: false,
    showProjects: false,
    showDependencies: false,
    showWorkspace: false,
    showCollaborators: false,
    showHorizon: false,
    showPriority: false,
    showStatus: false,
    workspaceRequired: false,
  },
  workspace: {
    type: 'workspace' as const,
    nameLabel: 'Name *',
    descriptionLabel: 'Description',
    descriptionRequired: false,
    showType: false,
    showDueDate: false,
    showAssignee: false,
    showProjects: false,
    showDependencies: false,
    showWorkspace: false,
    showCollaborators: true,
    showLogo: true,
    showEmail: true,
    workspaceRequired: false,
    showHorizon: false,
    showPriority: false,
    showStatus: false,
    collaboratorsLabel: 'Collaborators',
  },
  workspaceSimplified: {
    type: 'workspace' as const,
    nameLabel: 'Name *',
    descriptionLabel: 'Description *',
    descriptionRequired: true,
    showType: false,
    showDueDate: false,
    showAssignee: false,
    showProjects: false,
    showDependencies: false,
    showWorkspace: false,
    showCollaborators: true,
    showLogo: true,
    showEmail: true,
    showHorizon: false,
    showPriority: false,
    showStatus: false,
    workspaceRequired: false,
  },
  message: {
    type: 'message' as const,
    nameLabel: 'Subject *',
    descriptionLabel: 'Message *',
    descriptionRequired: true,
    showType: false,
    showDueDate: false,
    showAssignee: false,
    showProjects: true,
    showDependencies: false,
    showWorkspace: true,
    showCollaborators: false,
    showLogo: false,
    showEmail: false,
    showHorizon: false,
    showPriority: false,
    showStatus: false,
    workspaceRequired: false,
    // Message-specific features
    showDirectMessage: true,
    showFromField: true,
    showRecipients: true,
    recipientsLabel: 'Recipients',
    fromLabel: 'From',
    directMessageLabel: 'Message Type',
    projectsLabel: 'Projects',
  },
  document: {
    type: 'document' as const,
    nameLabel: 'Document Name *',
    descriptionLabel: 'Description *',
    descriptionRequired: true,
    showType: false,
    showDueDate: false,
    showAssignee: false,
    showProjects: true,
    showDependencies: true,
    showWorkspace: true,
    showCollaborators: true,
    showLogo: false,
    showEmail: false,
    showUrl: true,
    showHorizon: false,
    showPriority: false,
    showStatus: false,
    workspaceRequired: true,
    collaboratorsLabel: 'Collaborators',
    projectsLabel: 'Projects',
    dependenciesLabel: 'Tasks',
  },
  user: {
    type: 'user' as const,
    nameLabel: 'Full Name *',
    descriptionLabel: 'Description',
    descriptionRequired: false,
    showType: false,
    showDueDate: false,
    showAssignee: false,
    showProjects: true,
    showDependencies: false,
    showWorkspace: true,
    showCollaborators: false,
    showLogo: false,
    showEmail: true,
    showHorizon: false,
    showPriority: false,
    showStatus: false,
    workspaceRequired: false,
    showLocation: true,
    showRole: true,
    showTimezone: true,
    showUserStatus: true,
    showPassword: true,
    showConfirmPassword: true,
    emailLabel: 'Email Address',
    locationLabel: 'Location',
    roleLabel: 'Role',
    timezoneLabel: 'Timezone',
    userStatusLabel: 'Status',
    passwordLabel: 'Password',
    confirmPasswordLabel: 'Confirm Password',
  },
  userEdit: {
    type: 'user' as const,
    nameLabel: 'Name *',
    descriptionLabel: 'Description',
    descriptionRequired: false,
    showType: false,
    showDueDate: false,
    showAssignee: false,
    showProjects: false,
    showDependencies: false,
    showWorkspace: false,
    showCollaborators: false,
    showLogo: false,
    showEmail: true,
    showHorizon: false,
    showPriority: false,
    showStatus: false,
    workspaceRequired: false,
    showLocation: true,
    showRole: true,
    showTimezone: true,
    showUserStatus: true,
    showPassword: false,
    showConfirmPassword: false,
    emailLabel: 'Email Address',
    locationLabel: 'Location',
    roleLabel: 'Role',
    timezoneLabel: 'Timezone',
    userStatusLabel: 'Status',
  },
} as const
